import { SafeLink } from "@/components/ui/SafeLink";

interface CTAExploreMoreProps {
    text: string;  // The category or sub-category name (e.g., "Kitchen" or "Ovens")
    action?: string;  // Prefix like "Explore more" or "Back to" (default: "Explore more")
    suffix?: string;  // Suffix like "Products" (default: "Products")
    // onClick: () => void;
    to: string;
    className?: string;
}

export default function CTAExploreMore({
    text,
    action = "Explore More",
    suffix = "Products",
    // onClick,
    to,
    className = ""
}: CTAExploreMoreProps) {
    // Generate the full button text
    const fullText = `${action} ${text} ${suffix}`.trim();

    return (
        <div className="flex justify-center mt-12">
            {/* <button
                className={`bg-white text-harvey-red border border-harvey-red font-semibold px-8 py-3 rounded-lg shadow hover:bg-harvey-red hover:text-white transition  ${className}`}
                onClick={onClick}
            >
                {fullText}
            </button> */}
            <SafeLink
                to={to}
                className={`bg-white text-harvey-red border border-harvey-red font-semibold px-8 py-3 rounded-lg shadow hover:bg-harvey-red hover:text-white transition ${className}`}
            >
                {fullText}
            </SafeLink>
        </div>
    );
}